import type { CalidadControlModificacion } from "../../../types/control-modificaciones";

export type CalidadRiesgo = {
  id: number;
  anio: number;
  origen: string | null;
  numero: string;
  cuestiones: string | null;
  riesgos: string | null;
  procesos_afectados: string | null;
  decision_direccion: string | null;
  controles_acciones_implantar: string | null;
  responsable: string | null;
  plazos: string | null;
  recursos: string | null;
  eficacia_primer_semestre: string | null;
  eficacia_segundo_semestre: string | null;
  resultado_eficacia: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type CalidadOportunidad = {
  id: number;
  anio: number;
  origen: string | null;
  numero: string;
  oportunidades: string | null;
  procesos_afectados: string | null;
  viabilidad_oportunidad: string | null;
  controles_acciones_implantar: string | null;
  responsable: string | null;
  plazos: string | null;
  recursos: string | null;
  eficacia_primer_semestre: string | null;
  eficacia_segundo_semestre: string | null;
  resultado_eficacia: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type CalidadRiesgoPayload = Omit<CalidadRiesgo, "id" | "usuario_modificacion_id" | "created_at" | "updated_at">;
export type CalidadOportunidadPayload = Omit<CalidadOportunidad, "id" | "usuario_modificacion_id" | "created_at" | "updated_at">;

export type RiesgosOportunidadesFilters = {
  anio: string;
  search: string;
};

export type RiesgosOportunidadesResponse = {
  riesgos: CalidadRiesgo[];
  oportunidades: CalidadOportunidad[];
  control_modificaciones: CalidadControlModificacion[];
  meta: {
    years: number[];
    current_year: number;
    default_source_year: number | null;
    suggested_new_year: number;
    riesgos_total: number;
    oportunidades_total: number;
  };
};

export type PlantillaAnualPayload = {
  source_year: number;
  target_year: number;
  copy_riesgos: boolean;
  copy_oportunidades: boolean;
};

export const defaultRiesgosOportunidadesFilters: RiesgosOportunidadesFilters = {
  anio: "",
  search: "",
};

export function createEmptyRiesgoForm(anio?: number): CalidadRiesgoPayload {
  return {
    anio: anio ?? new Date().getFullYear(),
    origen: "",
    numero: "",
    cuestiones: "",
    riesgos: "",
    procesos_afectados: "",
    decision_direccion: "",
    controles_acciones_implantar: "",
    responsable: "",
    plazos: "",
    recursos: "",
    eficacia_primer_semestre: "",
    eficacia_segundo_semestre: "",
    resultado_eficacia: "",
  };
}

export function createEmptyOportunidadForm(anio?: number): CalidadOportunidadPayload {
  return {
    anio: anio ?? new Date().getFullYear(),
    origen: "",
    numero: "",
    oportunidades: "",
    procesos_afectados: "",
    viabilidad_oportunidad: "",
    controles_acciones_implantar: "",
    responsable: "",
    plazos: "",
    recursos: "",
    eficacia_primer_semestre: "",
    eficacia_segundo_semestre: "",
    resultado_eficacia: "",
  };
}

export function mapRiesgoToPayload(row: CalidadRiesgo): CalidadRiesgoPayload {
  return {
    anio: row.anio,
    origen: row.origen ?? "",
    numero: row.numero,
    cuestiones: row.cuestiones ?? "",
    riesgos: row.riesgos ?? "",
    procesos_afectados: row.procesos_afectados ?? "",
    decision_direccion: row.decision_direccion ?? "",
    controles_acciones_implantar: row.controles_acciones_implantar ?? "",
    responsable: row.responsable ?? "",
    plazos: row.plazos ?? "",
    recursos: row.recursos ?? "",
    eficacia_primer_semestre: row.eficacia_primer_semestre ?? "",
    eficacia_segundo_semestre: row.eficacia_segundo_semestre ?? "",
    resultado_eficacia: row.resultado_eficacia ?? "",
  };
}

export function mapOportunidadToPayload(row: CalidadOportunidad): CalidadOportunidadPayload {
  return {
    anio: row.anio,
    origen: row.origen ?? "",
    numero: row.numero,
    oportunidades: row.oportunidades ?? "",
    procesos_afectados: row.procesos_afectados ?? "",
    viabilidad_oportunidad: row.viabilidad_oportunidad ?? "",
    controles_acciones_implantar: row.controles_acciones_implantar ?? "",
    responsable: row.responsable ?? "",
    plazos: row.plazos ?? "",
    recursos: row.recursos ?? "",
    eficacia_primer_semestre: row.eficacia_primer_semestre ?? "",
    eficacia_segundo_semestre: row.eficacia_segundo_semestre ?? "",
    resultado_eficacia: row.resultado_eficacia ?? "",
  };
}
